export function replaceDoubleSlashes(url: string): string {
  // return url.replace(/(?<!https?:)\/\//g, '/');
  return url.replace(/([^:])\/\//g, '$1/');
}
